import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Handle, Position } from "reactflow";

const SwitchNode = ({ id, data, deleteNode }) => {
  const isOn = data?.defaultState !== undefined ? !!data.defaultState : !!data?.isOn;

  const handleToggle = (e) => {
    e.stopPropagation();
    if (data && typeof data.onToggleDefaultState === "function") {
      data.onToggleDefaultState(id);
    }
  };

  return (
    <div className="flex flex-col m-auto items-center justify-center relative bg-gray-800 h-[52px] w-[52px] rounded-md border border-slate-700 shadow-md">
      <button
        onClick={() => deleteNode(id)}
        className="absolute -top-2 -right-2 bg-red-600 hover:bg-red-700 text-white rounded-full w-5 h-5 text-sm flex items-center justify-center shadow-lg z-10"
        title="Delete Switch"
      >
        <DeleteIcon style={{ fontSize: "14px" }} />
      </button>

      <Handle type="source" id="output" position={Position.Top} />

      <div
        onClick={handleToggle}
        title={`Initial Start State: ${isOn ? "ON" : "OFF"} (Click to Toggle)`}
        className={`${
          isOn
            ? "bg-red-600 shadow-[0_0_12px_rgba(220,38,38,0.9)] border border-white"
            : "bg-red-950 border border-red-900 opacity-80 hover:opacity-100"
        } h-[36px] w-[36px] rounded-full cursor-pointer transition-all duration-200 flex items-center justify-center`}
      >
        <span className="text-[10px] font-bold text-white font-mono select-none">
          {isOn ? "ON" : "OFF"}
        </span>
      </div>
    </div>
  );
};

export default SwitchNode;
